import { NavbarBrand, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function ABPNNavLink() {

    return (
        <NavbarBrand as={Link} to="/">
            <Image style={{ height: "40px" }} src="/precert/ABPNlogoWhiteStacked.png" title="American Board of Psychiatry and Neurology, Inc." />
        </NavbarBrand>
    );
}
